import { render, staticRenderFns } from "./BbeeProductosServiciosComex.vue?vue&type=template&id=90ea9f4a"
import script from "./BbeeProductosServiciosComex.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosComex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports